import Vue from 'vue';
import Vuex from 'vuex';
import {config as vmdConfig} from 'vuex-module-decorators';

// По умолчанию vuex-module-decorators оборачивает ЛЮБОЙ error из тела @Action
// в сообщение ERR_ACTION_ACCESS_UNDEFINED, что маскирует реальную причину.
// Включаем rawError ДО загрузки классов с декораторами (этот файл импортируется
// каждым vuex-модулем, поэтому ранг гарантирован).
vmdConfig.rawError = true;

export type RootState = {};

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {},
  mutations: {},
  actions: {},
  modules: {},
});
